import api, { API } from "@/lib/api";

const DB_NAME = "vinonotas";
const STORE = "pending_tastings";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function notify(count) {
  window.dispatchEvent(new CustomEvent("offline-queue-changed", { detail: { count } }));
}

export async function enqueueTasting({ type, tastingId, payload }) {
  const db = await openDB();
  const rec = {
    id: (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random()),
    ts: Date.now(),
    type: type || "create",
    tastingId: tastingId || null,
    apiBase: API,
    payload,
  };
  await new Promise((res, rej) => {
    const t = db.transaction(STORE, "readwrite");
    t.objectStore(STORE).put(rec);
    t.oncomplete = res;
    t.onerror = () => rej(t.error);
  });
  notify(await pendingCount());
  registerBackgroundSync();
  return rec;
}

export async function getPending() {
  const db = await openDB();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, "readonly");
    const r = t.objectStore(STORE).getAll();
    r.onsuccess = () => res(r.result || []);
    r.onerror = () => rej(r.error);
  });
}

export async function pendingCount() {
  return (await getPending()).length;
}

async function removeItem(id) {
  const db = await openDB();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, "readwrite");
    t.objectStore(STORE).delete(id);
    t.oncomplete = res;
    t.onerror = () => rej(t.error);
  });
}

let flushing = false;

export async function flushQueue() {
  if (flushing || !navigator.onLine) return 0;
  flushing = true;
  let synced = 0;
  try {
    const items = await getPending();
    for (const it of items) {
      try {
        if (it.type === "update" && it.tastingId) {
          await api.put(`/tastings/${it.tastingId}`, it.payload);
        } else {
          await api.post("/tastings", it.payload);
        }
        await removeItem(it.id);
        synced += 1;
      } catch (err) {
        const status = err?.response?.status;
        if (status && status >= 400 && status < 500) {
          await removeItem(it.id); // dato inválido/duplicado: descartar para no reintentar en bucle
        } else {
          break; // problema de red: detener y reintentar más tarde
        }
      }
    }
  } finally {
    flushing = false;
    notify(await pendingCount());
  }
  return synced;
}

export function registerBackgroundSync() {
  if ("serviceWorker" in navigator && "SyncManager" in window) {
    navigator.serviceWorker.ready
      .then((reg) => reg.sync.register("sync-tastings"))
      .catch(() => {});
  }
}
